import { motion, useMotionValue, useSpring } from "framer-motion";
import { useRef } from "react";

export function MagneticLink({ href, children, label }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 18 });
  const sy = useSpring(y, { stiffness: 200, damping: 18 });

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - (rect.left + rect.width / 2)) * 0.38);
    y.set((e.clientY - (rect.top + rect.height / 2)) * 0.38);
  };
  const reset = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.a
      ref={ref}
      href={href}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      style={{ x: sx, y: sy }}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      whileHover={{ scale: 1.18 }}
      whileTap={{ scale: 0.9 }}
      className="group relative flex items-center justify-center w-12 h-12 rounded-full
        border border-white/[0.08] bg-white/[0.03] backdrop-blur-sm
        hover:border-[#00f0ff]/50 hover:bg-[#00f0ff]/8
        transition-colors duration-300 cursor-pointer"
    >
      {children}
    </motion.a>
  );
}
